import { OperationMS } from '../../types';
import { CommandeAnalyse } from '../analyse/types';
import { getNotificationDate } from '../analyse/historique';

// Resolution du retenu et des non-retenus pour l'onglet Marché. Le retenu = la commande
// dont l'id == operation.id_commande (persiste a la cloture de l'analyse).
const commandesAnalyse = (operation: OperationMS): CommandeAnalyse[] =>
  (operation.commandes ?? []) as CommandeAnalyse[];

export const getRetenuCommande = (operation: OperationMS): CommandeAnalyse | undefined =>
  commandesAnalyse(operation).find((c) => c.id === operation.id_commande);

// Non-retenus affichables (avec un nom d'entite et un montant) — reproduit le filtre legacy.
export const getNonRetenusCommandes = (operation: OperationMS): CommandeAnalyse[] =>
  commandesAnalyse(operation).filter(
    (c) =>
      c.id !== operation.id_commande &&
      !!c.contrat?.entite?.nom &&
      c.prix_total !== null &&
      c.prix_total !== undefined,
  );

// Cette commande a-t-elle ete notifiee ? (date de notification presente dans l'historique)
export const isCommandeNotifiee = (operation: OperationMS, commandeId?: number): boolean =>
  getNotificationDate(operation.historique, commandeId) !== null;
